module.exports = __webpack_public_path__ + "img/hyal-7.344b5a4c.png";